<template>
  <!-- eslint-disable -->
  <v-dialog persistent scrollable v-model="opened">
    <v-card>
      <v-card-title>
        <div style="width: 100%">
          <h4 class="mb-3">Select a Supplier</h4>
          <v-text-field
            append-icon="mdi-magnify"
            filled
            placeholder="Search by Name"
            v-model="searchValue"
          >
          </v-text-field>
        </div>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-data-table
          class="elevation-1"
          dense
          :headers="headers"
          :items="filteredSuppliers"
          :loading="loading"
        >
          <template v-slot:item.actions="{ item }">
            <v-layout justify-end>
              <v-btn color="primary" small text @click="onSelectClicked(item)">
                Select
              </v-btn>
            </v-layout>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="error" text @click="onCancelClicked">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "../api";
/* eslint-disable */

export default {
  props: {
    suppliers: {
      type: Array,
      required: true,
      default: false,
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
  }, // props

  data: () => ({
    opened: false,
    headers: [
      {
        text: "Internal Id",
        value: "internalId",
      },
      {
        text: "Name",
        value: "supplierName",
      },
      {
        text: "",
        value: "actions",
      },
    ],
    resolve: null,
    reject: null,
    searchValue: "",
  }), // data

  computed: {
    filteredSuppliers() {
      if (!this.searchValue) return this.suppliers;

      const search = this.searchValue.trim().toLowerCase();
      return this.suppliers.filter((s) =>
        s.supplierName.trim().toLowerCase().includes(search)
      );
    },
  }, // computed

  methods: {
    open() {
      this.opened = true;
    },
    openAndGetSupplierAsync() {
      this.open();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    close() {
      this.opened = false;
    },
    onCancelClicked() {
      if (this.reject) this.reject();

      this.close();
    },
    onSelectClicked(supplier) {
      if (this.resolve) this.resolve(supplier);

      this.$emit("supplierSelected", supplier);
      this.close();
    },
    async loadSuppliersAsync() {
      this.loading = true;
      try {
        this.suppliers = await api.suppliers.getFromCurrentUser();
      } finally {
        this.loading = false;
      }
    },
  }, // methods
};
</script>
